

import React, { useEffect } from 'react';

import CompanyListingsSection from '../../shared/CompanyListingsSection';
import FeaturedCampaigns from '../../shared/FeaturedCampaigns';
import SearchCompanySection from '../../shared/SearchCompanySection';

const CommunityListing = (props) => {
	const companyType = 'community';
	const { location, setPage, setSearchFilter, user, communityListings, getFeaturedCampaigns, shareCompany, followCompanyType, history, getCommunityListings } = props;
	const { filter, communities, pagination, featuredCampaigns, loading } = communityListings;
	const { data } = featuredCampaigns || {};
	const { state } = location || {};

	useEffect(() => {
		setSearchFilter(state && state.keyword ? state.keyword : '');
		getCommunityListings(companyType, user && user.id ? user.id : navigator.userAgent);
		getFeaturedCampaigns(companyType);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps 
	return (
		<div>
			<SearchCompanySection 
				companyType={companyType}
				user={user}
				filter={filter}
				setSearchFilter={setSearchFilter}
				getCompanyTypeListings={getCommunityListings}
			/>
			<section className="school-list-sec-2">
				<div className="container">
					<div className="gen-text-box">
						<h4 className="marker-text">School that you help</h4>
						<h3 className="heading">How you can Help Them</h3>
						<p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model.</p>
						<p>You will know that chat is available at the time you’re contacting us if you see both of the options shown above. If you do not see the option to click “Chat Now”,  lease either email our team or check back after one hour to see if chat is available.</p>
						<p>Please keep in mind, the GoFundMe Help Center is filled with several articles that may have the answer you are looking for. Before contacting our team, please use the search bar at the top of the page and search for keywords that are related to your question. Here are some examples:</p>
						<ul>
							<li>"Where are my donations?" - Keywords: Missing donations.</li>
							<li>"How can I remove my name from my donation?" - Keywords: Anonymous donation.</li>
							<li>"I need a refund" - Keywords: Refunds.</li>
							<li>"How do I close my GoFundMe fundraiser?" - Keywords: Deactivate fundraiser.</li>
						</ul>
					</div>
				</div>
			</section>
			<CompanyListingsSection
				setPage={setPage}
				pagination={pagination}
				data={communities}
				loading={loading}
				companyType={companyType}
				user={user}
				history={history}
				shareCompany={shareCompany}
				followCompanyType={followCompanyType}
				getCompanyTypeListings={getCommunityListings}
			/>
			<FeaturedCampaigns data={data} loading={loading} />

		</div >
	);
};

export default CommunityListing;
